export default "__VITE_ASSET__DWKpJpWY__"